import { TriggerType } from '../../../graphql';
import { TriggerConfig } from './triggerConfig';

export interface Trigger {
  type: TriggerType;
  config: TriggerConfig;
}
